// extracted by mini-css-extract-plugin
export default {"no-chats-label":"styles_no-chats-label__mSwD4"};